var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAspectRatioWidescreenLight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 34,
    viewBox: "0 0 68 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 33.5,
    width: 33,
    height: 67,
    transform: "rotate(-90 0.5 33.5)",
    fill: "#121212",
    stroke: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAspectRatioWidescreenLight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/aspect-ratio-widescreen-light.b9bb2c7694e62f93a08d24e4ba32f972.svg";